var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"svg-wrapper"},[_c('font-awesome-icon',{attrs:{"icon":[_vm.iconType, _vm.iconName]}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }